import { isProdEnvironment, isTestingEnvironment } from 'utilities/environment';

function getCallerStack() {
    const stack = new Error().stack;

    return stack?.split('\n')?.[3]?.trim() ?? 'stack trace not available';
}

const isDevLoggerNotAllowed = () => {
    return isProdEnvironment() || isTestingEnvironment();
};

/* eslint-disable no-console */
export const devLogger = {
    info: (...args) => {
        if (isDevLoggerNotAllowed()) return;
        console.log('[DEV INFO]', ...args, getCallerStack());
    },
    log: (...args) => {
        if (isDevLoggerNotAllowed()) return;
        console.log('[DEV LOG]', ...args, getCallerStack());
    },
    warn: (...args) => {
        if (isDevLoggerNotAllowed()) return;
        console.warn('[DEV WARN]', ...args, getCallerStack());
    },
    error: (...args) => {
        if (isDevLoggerNotAllowed()) return;
        console.error('[DEV ERROR]', ...args, getCallerStack());
    },
};
